import Link from "next/link";
import ShoppingCart from "./cart/shoppingCart";
import React, { useEffect, useState } from "react";
import MobileNavMenus from "./mobileNavMenus";
import MobileTopNavCta from "./mobileTopNavCta";
import { AccountNav, AccountValidation, BotBPass, MobileTopNavCTA, UserMenus } from "./types";
import Logo from "./logo";
import FunCentre from "./funCentre";
import Logout from "./logout";
import MyAccountNav from "./my-account-nav";
import BotBPassNavMenu from "./botbPassNavMenu";
import FounderBadge from "./founderBadge";
import AllCompetitions from "./allCompetitions";
import FeaturedCompetitionsNew from "./featuredCompetitionsNew";
import SpinAWheelNavMenuItemNew from "./spinAWheelNavMenuItemNew";
import UserInfo from "./userInfo";
import BlackFridayLeaderBoardNavMenu from "./blackFridayLeaderBoardNavMenu";
import SubscriberCompetitionsWidget from "./SubscriberCompetitionsWidget";
import PastDueNotification from "./pastDueNotification";
import CancelledNotification from "./cancelledNotification";
import LeaderboardChristmasBadge from "./leaderboardChristmasBadge";
import ChristmasRaffleNavMenu from "@/app/(general-header)/header/christmasRaffleNavMenu";
import FeaturedSubscriberCompetitions from "./featuredSubscriberCompetitions";
import { useCompetitionByType } from "@/app/redux/features/categories/selectors";
import FeelingLuckySection from "./feelingLuckySection";
import { isDevMode } from "@/lib/env";

type MobileHeaderProps = {
  botbPassNavMenu: BotBPass;
  topNavCTA: MobileTopNavCTA;
  userData: UserMenus;
  accountValidationContent: AccountValidation;
  accountNavData: AccountNav[];
  isBotBPassHeader: boolean;
  isFounderPage?: boolean;
  isLeaderBoardPage?: boolean;
  isLeaderBoardChristmasPage?: boolean;
  milestoneData: string;
  blackFridayLeaderboardNavMenu?: boolean;
  showPastDueBanner: boolean;
  onSnoozePastDue: () => void;
  showCancelationBanner: boolean;
  onSnoozeCancelation: () => void;
  IsRAFEnabled?: boolean;
};

const isRAFActive = false;
const areSpringPromotionsActive = true;

const HeaderForSmallScreens = ({
  topNavCTA,
  userData,
  accountValidationContent,
  accountNavData,
  botbPassNavMenu,
  isBotBPassHeader,
  isFounderPage = false,
  isLeaderBoardPage = false,
  isLeaderBoardChristmasPage = false,
  milestoneData,
  blackFridayLeaderboardNavMenu,
  showPastDueBanner,
  onSnoozePastDue,
  showCancelationBanner,
  onSnoozeCancelation,
  IsRAFEnabled = false,
}: MobileHeaderProps) => {
  const [isMobileNavMenusVisible, setIsMobileNavMenusVisible] = useState(false); //TEMP on TRUE

  useEffect(() => {
    const onScrollToCategory = () => {
      setIsMobileNavMenusVisible(false);
    };
    window.addEventListener("scroll-to-category", onScrollToCategory);

    return () => {
      window.removeEventListener("scroll-to-category", onScrollToCategory);
    };
  }, []);

  useEffect(() => {
    if (!isMobileNavMenusVisible) {
      document.body.style.overflow = "";
      return;
    }

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isMobileNavMenusVisible]);

  const now = new Date();
  const targetDate = new Date("2025-12-31T23:59:59");
  const timezoneOffset = new Date().getTimezoneOffset() * 60000;
  const englandTargetDate = new Date(targetDate.getTime() - timezoneOffset);
  const targetDateChristmasDraws = new Date("2026-01-02T20:58:59");
  const englandTargetDateChristmasDraws = new Date(targetDateChristmasDraws.getTime() - timezoneOffset);
  const isDecember = englandTargetDate.getTime() - now.getTime() > 0;
  const isJanuary = englandTargetDateChristmasDraws.getTime() - now.getTime() > 0;

  const subscriberCategory = useCompetitionByType("subscriberCompetitions");

  const openMobileNavMenus = () => (
    <div className="fixed top-0 left-0 bottom-0 right-0 bg-[rgba(0,0,0,0.7)] z-[1002]">
      <div className="absolute xs:w-full md:w-1/2 h-full p-3 bg-gray-4 overflow-y-auto z-10 pb-[38px]">
        <button
          type="button"
          aria-label="Close menu"
          onClick={() => setIsMobileNavMenusVisible(false)}
          className="fixed top-3 left-[7px] z-20 cursor-pointer">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <circle cx="16" cy="16" r="16" fill="white"></circle>
            <path
              d="M22 10L10 22M10 10L22 22"
              stroke="#898994"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"></path>
          </svg>
        </button>
        <div className="flex flex-col gap-8 mt-[46px]">
          {userData?.IsAuthenticated && <UserInfo userData={userData} />}

          {botbPassNavMenu && (
            <div className="flex flex-col gap-4">
              <BotBPassNavMenu navMenuData={botbPassNavMenu} />
              {subscriberCategory ? <FeaturedSubscriberCompetitions /> : null}
            </div>
          )}
          {isRAFActive && <LeaderboardChristmasBadge isPlacedInMenu={true} IsRAFEnabled={IsRAFEnabled} />}

          <FeaturedCompetitionsNew />

          {areSpringPromotionsActive ? <FeelingLuckySection /> : null}

          {(isDecember || isJanuary) && (
            <div>
              <div className="text-gray-1 font-jost text-xs font-medium leading-4 lg:text-sm lg:leading-5">
                A DECEMBER TO REMEMBER
              </div>
              {isDecember && <BlackFridayLeaderBoardNavMenu />}
              {isJanuary && <ChristmasRaffleNavMenu />}
              <SubscriberCompetitionsWidget />
            </div>
          )}

          <AllCompetitions />

          <SpinAWheelNavMenuItemNew userData={userData} />

          <MobileNavMenus userData={userData} accountValidationContent={accountValidationContent} />
          <MyAccountNav accountNavData={accountNavData} />
          <MobileTopNavCta {...topNavCTA} />
          {userData?.IsAuthenticated && <Logout />}
        </div>
      </div>
    </div>
  );

  const getBurgerMenu = () => (
    <svg
      className="cursor-pointer"
      onClick={() => setIsMobileNavMenusVisible(true)}
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.66675 7.46143H23.3334M4.66675 14.4614H23.3334M4.66675 21.4614H23.3334"
        stroke="#4C4C52"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"></path>
    </svg>
  );

  const getBackButton = () => (
    <svg
      className="cursor-pointer"
      onClick={() => history.go(-1)}
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none">
      <path
        d="M6.66602 16H25.3327M6.66602 16L14.666 24M6.66602 16L14.666 8"
        stroke="#4C4C52"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <>
      <div
        className={`header-el flex items-center h-[57px] px-3 justify-between border-b-[1px] border-solid border-[#ccc] header-container`}>
        <div className="flex gap-1.5">
          {isBotBPassHeader ? getBackButton() : getBurgerMenu()}
          <Logo />
        </div>
        {milestoneData && (
          <div
            className="gap-1 flex items-center descriptionContainer"
            dangerouslySetInnerHTML={{ __html: milestoneData }}
          />
        )}
        {!isBotBPassHeader && (
          <div className="gap-3 flex items-center mobile-nav-menus">
            {userData?.IsAuthenticated && userData?.FunCentre !== null && (
              <FunCentre
                smarticoData={userData?.FunCentre}
                classNames="xs:w-20"
                funCentreLogoClassNames="xs:w-[28px] xs:h-[28px]"
                funCentreTextClassNames="xs:text-[10px]"
              />
            )}
            {!userData?.IsAuthenticated && (
              <Link href={isDevMode ? "/login" : userData?.LoginUrl || "#"} title="LOG IN">
                <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M7.196 22.4519C7.48476 21.4909 8.07563 20.6485 8.88095 20.0497C9.68628 19.451 10.6632 19.1278 11.6667 19.1281H16.3333C17.3381 19.1277 18.3162 19.4517 19.1221 20.0518C19.928 20.652 20.5187 21.4962 20.8063 22.4589M3.5 14.4614C3.5 15.8403 3.77159 17.2057 4.29926 18.4796C4.82694 19.7535 5.60036 20.911 6.57538 21.886C7.55039 22.8611 8.70791 23.6345 9.98182 24.1622C11.2557 24.6898 12.6211 24.9614 14 24.9614C15.3789 24.9614 16.7443 24.6898 18.0182 24.1622C19.2921 23.6345 20.4496 22.8611 21.4246 21.886C22.3996 20.911 23.1731 19.7535 23.7007 18.4796C24.2284 17.2057 24.5 15.8403 24.5 14.4614C24.5 13.0825 24.2284 11.7172 23.7007 10.4432C23.1731 9.16933 22.3996 8.01182 21.4246 7.0368C20.4496 6.06179 19.2921 5.28837 18.0182 4.76069C16.7443 4.23302 15.3789 3.96143 14 3.96143C12.6211 3.96143 11.2557 4.23302 9.98182 4.76069C8.70791 5.28837 7.55039 6.06179 6.57538 7.0368C5.60036 8.01182 4.82694 9.16933 4.29926 10.4432C3.77159 11.7172 3.5 13.0825 3.5 14.4614ZM10.5 12.1281C10.5 13.0563 10.8687 13.9466 11.5251 14.603C12.1815 15.2593 13.0717 15.6281 14 15.6281C14.9283 15.6281 15.8185 15.2593 16.4749 14.603C17.1313 13.9466 17.5 13.0563 17.5 12.1281C17.5 11.1998 17.1313 10.3096 16.4749 9.65322C15.8185 8.99684 14.9283 8.62809 14 8.62809C13.0717 8.62809 12.1815 8.99684 11.5251 9.65322C10.8687 10.3096 10.5 11.1998 10.5 12.1281Z"
                    stroke="#4C4C52"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            )}
            {userData?.IsAuthenticated && userData?.MyAvatar !== null && (
              <Link href={"/account"} title={userData?.MyAvatar.ProfileTitle}>
                {userData?.MyAvatar.ProfileImageURL ? (
                  <img
                    src={userData?.MyAvatar.ProfileImageURL}
                    alt="user-avatar-image"
                    className="border-2 border-solid border-[#ff8200] overflow-hidden max-w-[44px] max-h[44px] rounded-full"
                  />
                ) : (
                  <svg
                    className="cursor-pointer"
                    width="28"
                    height="29"
                    viewBox="0 0 28 29"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M7.196 22.4519C7.48476 21.4909 8.07563 20.6485 8.88095 20.0497C9.68628 19.451 10.6632 19.1278 11.6667 19.1281H16.3333C17.3381 19.1277 18.3162 19.4517 19.1221 20.0518C19.928 20.652 20.5187 21.4962 20.8063 22.4589M3.5 14.4614C3.5 15.8403 3.77159 17.2057 4.29926 18.4796C4.82694 19.7535 5.60036 20.911 6.57538 21.886C7.55039 22.8611 8.70791 23.6345 9.98182 24.1622C11.2557 24.6898 12.6211 24.9614 14 24.9614C15.3789 24.9614 16.7443 24.6898 18.0182 24.1622C19.2921 23.6345 20.4496 22.8611 21.4246 21.886C22.3996 20.911 23.1731 19.7535 23.7007 18.4796C24.2284 17.2057 24.5 15.8403 24.5 14.4614C24.5 13.0825 24.2284 11.7172 23.7007 10.4432C23.1731 9.16933 22.3996 8.01182 21.4246 7.0368C20.4496 6.06179 19.2921 5.28837 18.0182 4.76069C16.7443 4.23302 15.3789 3.96143 14 3.96143C12.6211 3.96143 11.2557 4.23302 9.98182 4.76069C8.70791 5.28837 7.55039 6.06179 6.57538 7.0368C5.60036 8.01182 4.82694 9.16933 4.29926 10.4432C3.77159 11.7172 3.5 13.0825 3.5 14.4614ZM10.5 12.1281C10.5 13.0563 10.8687 13.9466 11.5251 14.603C12.1815 15.2593 13.0717 15.6281 14 15.6281C14.9283 15.6281 15.8185 15.2593 16.4749 14.603C17.1313 13.9466 17.5 13.0563 17.5 12.1281C17.5 11.1998 17.1313 10.3096 16.4749 9.65322C15.8185 8.99684 14.9283 8.62809 14 8.62809C13.0717 8.62809 12.1815 8.99684 11.5251 9.65322C10.8687 10.3096 10.5 11.1998 10.5 12.1281Z"
                      stroke="#4C4C52"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"></path>
                  </svg>
                )}
              </Link>
            )}
            {document.querySelector(".checkout") === null && <ShoppingCart />}
          </div>
        )}
        {isFounderPage && (
          <div className={"ml-auto"}>
            <FounderBadge />
          </div>
        )}
        {isLeaderBoardChristmasPage && (
          <div className={"ml-auto flex items-center"}>
            <LeaderboardChristmasBadge IsRAFEnabled={IsRAFEnabled} />
          </div>
        )}
      </div>
      {showPastDueBanner ? <PastDueNotification onSnooze={onSnoozePastDue} /> : null}
      {!isBotBPassHeader && !showPastDueBanner && showCancelationBanner ? (
        <CancelledNotification onSnooze={onSnoozeCancelation} />
      ) : null}
      {isMobileNavMenusVisible && openMobileNavMenus()}
    </>
  );
};

export default HeaderForSmallScreens;
